<template>
    <main>
      <headerPlataforma></headerPlataforma>
      <div>
        <router-view/>
      </div>
    </main>
</template>
<script>
import headerPlataforma from "./../components/Header/HeaderPlataforma"

export default {
  data () {
    return {
    }
  },
  components: {
    headerPlataforma,
  },
  mounted() {
  },
  

}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/layouts/PlataformaLayout.vue